import { render, staticRenderFns } from "./GuestLayout.vue?vue&type=template&id=21358833&"
import script from "./GuestLayout.vue?vue&type=script&lang=js&"
export * from "./GuestLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21358833')) {
      api.createRecord('21358833', component.options)
    } else {
      api.reload('21358833', component.options)
    }
    module.hot.accept("./GuestLayout.vue?vue&type=template&id=21358833&", function () {
      api.rerender('21358833', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/GuestLayout.vue"
export default component.exports